import { render, staticRenderFns } from "./water-quality-detail.vue?vue&type=template&id=29828e2e&scoped=true"
import script from "./water-quality-detail.vue?vue&type=script&lang=js"
export * from "./water-quality-detail.vue?vue&type=script&lang=js"
import style0 from "./water-quality-detail.vue?vue&type=style&index=0&id=29828e2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29828e2e",
  null
  
)

export default component.exports